import React, { useState, useEffect } from "react";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import { TabViews } from "../../Student/Reusablecomponents/RegularFunctions";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { TabViewValues } from "../../ReusableComponents/CommonFunctions";
import { useSelector, useDispatch } from "react-redux";
import { Languages } from "../../ReusableComponents/CommonFunctions";
import { SelectLanguageData } from "../../Redux/Reducers/Common/Language";
const ProgressTracker = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const items = useSelector((state) => state.userDetailsData.LoginDetails);

  const Tabs = [
    { Name: "Scenario based Questions", Value: "SCQ" },
    { Name: "Direct Questions", Value: "DQ" },
    { Name: "Input based Questions", Value: "INQ" },
  ];

  return (
    <>
      <div className="TeacherBgImage">
        <InternetChecking />
        <TabViewValues
          Tabs={Tabs}
          Selectedtab={location.state?.Tab}
          onClick={(e) => {
            navigate(`/QBAdmin/Progresstracker`, { state: { Tab: e } });
            // ChangeTab(e);
          }}
        />
        <div className=" alignitems">
          <div
            className="dflex alignitems gap-2"
            style={{ position: "absolute", left: "80vw" }}
          >
            {!location.pathname.includes("/DrillDown") &&
              !location.pathname.includes("/TranslateQuestion") &&
              !location.pathname.includes("/AddUpdateQuestions") && 
              ![3,4,5].includes(parseInt(items?.subjectId)) &&(
                <>
                  <span className="DropdownHeader">Select Language : </span>{" "}
                  <Languages
                    onChange={(e) => {
                      dispatch(SelectLanguageData({ SLanguage: e }));
                    }}
                  />
                </>
              )}
          </div>
        </div>
        <Outlet />
      </div>
    </>
  );
};
export default ProgressTracker;
